import { useCurrentUser } from '@qualio/ui-components';
import { useQuery, UseQueryResult } from 'react-query';
import { documentApi } from '../../../../../api/document';
import { DocumentStatus } from '../../../../../api/model/document';
import { documentAllOpenStatuses } from '../constants';

export const useParentCompanyName = (
  enabled: boolean,
): UseQueryResult<string | null> => {
  const currentUser = useCurrentUser();

  return useQuery({
    queryKey: ['parent-company-name', currentUser.companyId],
    queryFn: async () => {
      const parentCompanyDocument =
        await documentApi.fetchFirstParentCompanyDocument(currentUser, [
          ...documentAllOpenStatuses,
          DocumentStatus.Retired,
        ]);
      return parentCompanyDocument?.parent_company?.name ?? null;
    },
    enabled,
    refetchOnWindowFocus: false,
  });
};
